import { ACT_EVT_CHANGE } from "../actions/ActionTypes";

const initialState = {
  eventList:[],
	ticketList:{items:[],size:0},
	categoryList:[],
	stats:{},
	event:{}
};

export default function(state = initialState, action) {
	if (action.type === ACT_EVT_CHANGE) {
		return Object.assign({}, state, action.props);
	}
	return state;
}



// WEBPACK FOOTER //
// ./src/reducers/EventReducer.js